export const LOGIN_LINKS_DOWNLOAD_TASK_NAME = 'login-links-download';
export const LOGIN_LINKS_DOWNLOAD_FILE_NAME = 'Login-links-report';

export const LOGIN_LINKS_FILE_HEADERS = {
    id: 'ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    loginLink: 'Login Link',
    error: 'Error',
};
